import { authToken } from '@/modules/cohort/researchPermissions.js'


import axios from 'axios';
import {getCurrentInstance} from 'vue';
import {ElMessageBox} from 'element-plus';
import {store} from './store'; // 确保路径正确

// 开发环境优先走同源代理（vite.config.js 已配置 /a/ 代理到 sleepreport.wuji.com）
// 这样可避免浏览器跨域导致“页面能打开但波形数据不出”的情况
const isLocalDev =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
    (typeof import.meta !== 'undefined' ? !!import.meta.env?.DEV : process.env.NODE_ENV === 'development');

const devA = isLocalDev ? '/a/' : 'https://sleepreport.wuji.com/a/';

const endpoints_debug = {
    '计算服务器1': devA,
    '计算服务器2': devA,
    '数据服务器': devA,
    '收集': devA,  // 兼容 wuji_manager 的命名
    'API服务器': 'https://api.wuji.com/',  // 新优化接口专用
};
const endpoints_production = {
    '计算服务器1': 'https://sleepreport.wuji.com/a/',
    '计算服务器2': 'https://sleepreport.wuji.com/a/',
    '数据服务器': 'https://sleepreport.wuji.com/a/',  // 保持旧接口不变
    '收集': 'https://sleepreport.wuji.com/a/',  // 兼容 wuji_manager 的命名
    'API服务器': 'https://api.wuji.com/',      // 新优化接口专用
}

function get_base_url() {
    if (process.env.NODE_ENV === 'development') {
        return endpoints_debug['开发环境'];
    } else {
        return endpoints_production['数据服务器'];
    }
}

export const axiosInstance = axios.create({
    baseURL: get_base_url(), // 动态设置基础 URL
});

export function get_endpoints() {
    if (process.env.NODE_ENV === 'development') {
        return endpoints_debug;
    } else {
        return endpoints_production;
    }
}

export function get_endpoint(serverType) {
    if (process.env.NODE_ENV === 'development') {
        return endpoints_debug[serverType];
    } else {
        return endpoints_production[serverType];
    }
}


export async function request_data(url, serverType = "数据服务器") {
    try {
        const axiosInstance = createAxiosInstance(serverType);
        const response = await axiosInstance.get(url); // 使用新的 axios 实例请求数据
        if (response && response.status === 200 && response.data) {
            return response.data.data; // 假设响应的数据结构是 { data: { data: ... } }
        }
    } catch (error) {
        console.error("请求数据时发生错误:", error);
    }
    return null; // 如果请求失败或数据不满足条件，返回null
}

export function createAxiosInstance(serverType) {
    const endpoints = get_endpoints();
    const isAuthenticated1 = localStorage.getItem('authToken1_org')
    const isAuthenticated = localStorage.getItem('authToken_org')


    let baseURL = endpoints['数据服务器']; // 默认使用实验服务器
    if (serverType && endpoints[serverType]) {
        baseURL = endpoints[serverType];
    }
    let token = localStorage.getItem('authToken_org');
    if(!token &&!isAuthenticated && isAuthenticated1){  
         token = isAuthenticated1
      }
    // 确保 token 格式正确（Bearer 前缀）
    let authHeader = token
    if (token && !token.startsWith('Bearer ') && !token.startsWith('bearer ')) {
        authHeader = 'Bearer ' + token
      }
    let a = axios.create({
        baseURL: baseURL,
        // withCredentials: true
        headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader
        },
    });
    // // 添加请求拦截器
    // a.interceptors.request.use(config => {
    //     // 在这里获取token并添加到请求头中
    //     const token = localStorage.getItem('authToken');
    //     if (token) {
    //         config.headers.Authorization = `${token}`;
    //     }
    //     return config;
    // });
    a.interceptors.response.use(response => response, error => {
        // A response from an old account must not clear/redirect the new session.
        if (token && token !== authToken()) return Promise.reject(error);
        if (error.response && error.response.status === 401) {
            // 登录过期，清除认证信息并重定向到登录页
            const currentPath = window.location.pathname;
            const isExternalRaw = currentPath.startsWith('/external/raw')
            
            // 如果已经在登录页，不需要重定向
            if (currentPath === '/login' || currentPath.includes('/login')) {
                console.log('[axios拦截器] 检测到401错误，但已在登录页，跳过重定向');
                return Promise.reject(error);
            }

            // 外部原始数据页面：不强制跳登录，交给页面内提示（方便外部用户通过 token 链接访问）
            if (isExternalRaw) {
                console.warn('[axios拦截器] 外部原始数据页面检测到401，跳过重定向到登录页');
                return Promise.reject(error);
            }
            
            console.log('[axios拦截器] 检测到401错误，登录已过期，清除认证信息并重定向到登录页');
            store.commit('setUser', null);
            store.commit('clearUser');
            localStorage.removeItem('authToken_org');
            localStorage.removeItem('authToken1_org');
            localStorage.removeItem('userOrg');
            
            // 使用window.location重定向到登录页（避免循环依赖）
            // 延迟一下，确保其他清理操作完成，避免重复重定向
            setTimeout(() => {
                if (window.location.pathname !== '/login' && !window.location.pathname.includes('/login')) {
                    window.location.href = '/login';
                }
            }, 100);
        } else if (!error.response) {
            store.commit('setNetError', '网络或系统故障，请稍后重连');
        } else {
            store.commit('setNetError', '服务器错误，类型:' + error.response.status);
        }
        return Promise.reject(error);
    });

    return a;
}

export async function do_task(taskurl, args, serverType = "数据服务器") {
    const params = Object.keys(args)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(args[key])}`)
        .join('&');
    if (!taskurl.endsWith("/")) taskurl = taskurl + "/";
    const response = await request_data(taskurl + "?" + params, serverType);

    ElMessageBox.alert(response.message);
    return response.result;
}

export async function wdb_get(db, item, tag, time) {
    //console.log("wdb_get",db,item,tag,time)
    let url = "";
    if (tag) url = '/wdb/' + db + '/' + item + '/' + tag + '/';
    else if (item) url = '/wdb/' + db + '/' + item + '/';
    else if (db) url = '/wdb/' + db + '/';
    else url = '/wdb/';
    if (time)
        url += '?time=' + time;
    return request_data(url);
}

export async function wdb_get_new(serverType, db, item, tag, time) {
    //console.log("wdb_get",db,item,tag,time)
    let url = "";
    if (tag) url = '/wdb/' + db + '/' + item + '/' + tag + '/';
    else if (item) url = '/wdb/' + db + '/' + item + '/';
    else if (db) url = '/wdb/' + db + '/';
    else url = '/wdb/';
    if (time)
        url += '?time=' + time;
    return request_data(url, serverType);
}

export async function wdb_get_history(db, item, history = 0) {
    let url = "";
    if (item) url = '/wdb/' + db + '/' + item + '/';
    else if (db) url = '/wdb/' + db + '/';
    else url = '/wdb/';
    if (history) url += '?history=' + history;
    return request_data(url);
}

export async function wdb_get_history_new(serverType, db, item, history = 0) {
    let url = "";
    if (item) url = '/wdb/' + db + '/' + item + '/';
    else if (db) url = '/wdb/' + db + '/';
    else url = '/wdb/';
    if (history) url += '?history=' + history;
    return request_data(url, serverType);
}

// /sys/wdb/{action}/ 路由封装已下线（2026-06-25 sleep 容器化 C-7 砍）
// 原 4 个 export（sys_wdb_get / sys_wdb_add / sys_wdb_edit / sys_wdb_del）+ sysWdbAction
// 仅 WaveformToolbar.vue 用到，该组件已删（无人 import）。

export function useAxios() {
    const instance = getCurrentInstance();
    if (!instance) {
        throw new Error('useAxios must be called within a component setup');
    }
    // 直接返回axiosInstance，而不是通过globalProperties
    return createAxiosInstance("数据服务器");
}

/**
 * 通过手机号获取用户信息（替代旧 /userinfo/{phone}/ 接口）
 * 返回扁平结构：{user_id, nickname, sex, height, weight, birthdate, openid, phone_number, ...}
 * 失败返回 null
 */
export async function fetchUserProfile(phone, serverType = "数据服务器") {
    if (!phone) return null;
    try {
        const data = await request_data(`/users/v2/?search=${encodeURIComponent(phone)}&pagesize=1`, serverType);
        const nodes = data?.nodes || [];
        return nodes.length > 0 ? nodes[0] : null;
    } catch (e) {
        console.warn('[fetchUserProfile] 查询失败:', phone, e);
        return null;
    }
}
